import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Container, LabelBox, Title, Info } from './styles'
import { QRCodeSVG } from 'qrcode.react'
import { physicalLocationsService } from '../../services/physicalLocations.service'

const PrintPhysicalQRCode = () => {
  const { id } = useParams<{ id: string }>()
  const [locationName, setLocationName] = useState<string>('Carregando...')
  const [locationType, setLocationType] = useState<string>('')

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        if (!id) return;
        const response = await physicalLocationsService.findById(id);
        setLocationName(response.data.name || 'Local Físico')
        setLocationType(response.data.type || '')
      } catch (error) {
        setLocationName('Local Físico não encontrado')
      } finally {
        setTimeout(() => {
          window.print()
        }, 800)
      }
    }
    
    if (id) {
      fetchLocation()
    }
  }, [id])

  return (
    <Container>
      <LabelBox>
        <Title>{locationName} {locationType ? `(${locationType})` : ''}</Title>
        <QRCodeSVG 
          value={`${window.location.origin}/physical-archive/${id}`}
          size={150}
        />
        <Info>ID do Arquivo: {id}</Info>
      </LabelBox>
    </Container>
  )
}

export default PrintPhysicalQRCode
